export default __webpack_public_path__ + "static/media/problema-01.e0981a2c.webp";